export const WORKING_OFF_ITEMS = [
  {
    id: 'bachelor',
    label: 'Бакалавриат',
    badge: 'Для выпускников бакалавриата',
    title: 'Информация по отработке грантов - Бакалавриат',
    description:
      'Молодые специалисты, обучавшиеся по государственному образовательному гранту, обязаны пройти отработку в соответствии с условиями гранта.',
    sections: [
      {
        heading: '1. Сельская квота',
        points: [
          'Педагогические специальности - трёхлетняя или соразмерная отработка в организациях образования, расположенных в сельской местности (школы, спортивные школы, музыкальные школы, интернаты, детские сады и т.д.).',
          'Медицинские специальности - трёхлетняя или соразмерная отработка в организациях здравоохранения, расположенных в сельской местности (поликлиника, больница, стоматологические клиники, частные клиники, санаторий и т.д.).',
          'Ветеринарные специальности - трёхлетняя или соразмерная отработка в ветеринарных организациях, расположенных в сельской местности.',
          'Сельскохозяйственные специальности - трёхлетняя или соразмерная отработка в организациях аграрного профиля, расположенных в сельской местности.',
        ],
      },
      {
        heading: '2. Госзаказ',
        points: [
          'Педагогические специальности - трёхлетняя или соразмерная отработка в организациях образования (организации высшего и (или) послевузовского образования, колледжи, школы, спортивные школы, музыкальные школы, интернаты, детские сады и т.д.).',
          'Медицинские специальности - трёхлетняя или соразмерная отработка в организациях здравоохранения (поликлиники, больницы, стоматологические клиники, частные клиники, санаторий и т.д.).',
        ],
      },
      {
        heading: '3. Программа «Мәңгілік ел жастары-индустрияға» (Серпін)',
        points: [
          'Двухлетняя или соразмерная отработка только в регионах, перечень которых определён в приложении 2 к ПП РК от 4 сентября 2023 года № 765.',
          'Регионы для отработки: Восточно-Казахстанская, Костанайская, Павлодарская, Северо-Казахстанская, Карагандинская, Акмолинская области, область Абай, область Ұлытау.',
        ],
      },
      {
        heading: '4. Госзаказ (другие специальности)',
        points: [
          'Трёхлетняя или соразмерная отработка в организациях независимо от формы собственности.',
        ],
      },
    ],
  },
  {
    id: 'magistracy',
    label: 'Магистратура',
    badge: 'Для выпускников магистратуры',
    title: 'Информация по отработке грантов - Магистратура',
    description:
      'Молодые специалисты, окончившие магистратуру по государственному образовательному гранту, обязаны пройти отработку в соответствии со своей специальностью.',
    sections: [
      {
        heading: null,
        points: [
          'Педагогические специальности - трёхлетняя или соразмерная отработка в организациях образования (организации высшего и (или) послевузовского образования, колледжи, школы, спортивные школы, музыкальные школы, интернаты, детские сады и т.д.).',
          'Медицинские специальности - трёхлетняя или соразмерная отработка в организациях здравоохранения (поликлиники, больницы, стоматологические клиники, частные клиники, санаторий и т.д.).',
          'Другие специальности - трёхлетняя или соразмерная отработка в организациях независимо от формы собственности.',
        ],
      },
    ],
  },
  {
    id: 'doctoral',
    label: 'Докторантура',
    badge: 'Для выпускников докторантуры',
    title: 'Информация по отработке грантов - Докторантура',
    description:
      'Выпускники докторантуры обязаны пройти отработку не менее трёх лет в профильных организациях после завершения срока обучения.',
    sections: [
      {
        heading: null,
        points: [
          'Доктора философии (PhD) - отрабатывают в государственных органах, организациях высшего и (или) послевузовского образования, научных организациях, научных подразделениях, автономных организациях образования «Назарбаев Интеллектуальные школы», в организациях образования, реализующих образовательные программы послесреднего образования (в высших колледжах или училищах), не менее трёх лет после завершения срока обучения.',
          'Доктора по профилю - отрабатывают в государственных органах, организациях высшего и (или) послевузовского образования, научных организациях, научных подразделениях, автономных организациях образования «Назарбаев Интеллектуальные школы», в организациях образования, реализующих образовательные программы послесреднего образования (в высших колледжах или училищах), не менее трёх лет после завершения срока обучения.',
        ],
      },
    ],
  },
  {
    id: 'payment',
    label: 'Оплата задолженности',
    badge: 'Оплата задолженности',
    title: 'Оплата задолженности',
    description: 'При оплате задолженности необходимо точно указывать фамилию, имя, отчество, ИИН молодого специалиста.',
    sections: [
      {
        heading: null,
        points: [
          'Для получения необходимой информации и справки об отсутствии задолженности, а также по исполнению обязанности по отработке, просим обратиться в АО «Финансовый центр» по следующим контактным данным:',
          '010000, г. Астана, пр. Мәңгілік Ел 18',
          'тел/факс: 8 7172 695-032, 695-034, 695-047, 695-056, 695-057',
        ],
      },
    ],
  },
];
